import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RegionsI, StateI } from '@bodyanalytics/data-models-ui';
import { ApiLocalRoutesEnum } from '../../enums/api-routes.enum';
import { BaseHttpCrudService } from '../../+http/base-http-crud.service';

@Injectable({
  providedIn: 'root',
})
export class LookupDataService extends BaseHttpCrudService {
  private readonly statesUrl = `${ApiLocalRoutesEnum.API_SUFFIX_PUB_TEST_EVENTS_STATES}`;
  private readonly regionsUrl = `${ApiLocalRoutesEnum.API_SUFFIX_REGIONS}`;

  getStates(): Observable<StateI[]> {
    return this.getResource<StateI[]>(this.statesUrl, {
      op: 'getStates',
      log: 'fetched states',
      fallback: [],
    });
  }

  getRegions(): Observable<RegionsI[]> {
    return this.getResource<RegionsI[]>(this.regionsUrl, {
      op: 'getRegions',
      log: 'fetched regions',
      fallback: [],
    });
  }
}
